import React from 'react';
import { DatePicker, Form, Input, Modal, Spin, Typography } from 'antd';
import { DOCUMENT_UI_DATETIME_FORMAT } from '../../../../utils/documentUiFormat';
import { CLOSING_PACKAGE_MODAL_TITLES } from '../../workspace/closingPackageModalKinds';
import { useSendViaEdoModal } from '../../hooks/useSendViaEdoModal';
import ClosingPackageTaskModalContext from './ClosingPackageTaskModalContext';
import ClosingPackageTaskModalEventDateHint from './ClosingPackageTaskModalEventDateHint';
import ClosingPackageTaskModalFooter from './ClosingPackageTaskModalFooter';
import type { ClosingPackageTaskModalBaseProps } from './ClosingPackageFormationModal.types';

const { Text } = Typography;

export type ClosingPackageSendViaEdoModalProps = ClosingPackageTaskModalBaseProps & {
  onSuccess?: () => void | Promise<void>;
};

const ClosingPackageSendViaEdoModal: React.FC<ClosingPackageSendViaEdoModalProps> = ({
  open,
  onClose,
  applicationId,
  onSuccess,
}) => {
  const { form, projection, contextView, contextLoading, submitting, handleSubmit } =
    useSendViaEdoModal({
      applicationId,
      open,
      onClose,
      onSuccess,
    });

  return (
    <Modal
      title={CLOSING_PACKAGE_MODAL_TITLES['send-via-edo']}
      open={open}
      onCancel={onClose}
      destroyOnClose
      width={760}
      data-testid="send-via-edo-modal"
      footer={
        <ClosingPackageTaskModalFooter
          onClose={onClose}
          onSubmit={handleSubmit}
          submitting={submitting}
          submitLabel="Зафиксировать отправку через ЭДО"
          submitTestId="send-via-edo-submit"
        />
      }
    >
      {contextLoading || !projection ? (
        <div style={{ textAlign: 'center', padding: 32 }}>
          <Spin />
        </div>
      ) : (
        <>
          <ClosingPackageTaskModalContext contextView={contextView} />

          <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
            Бухгалтер фиксирует, что комплект отправлен клиенту через ЭДО. Подготовка бумажных
            оригиналов не требуется.
          </Text>

          <Form form={form} layout="vertical">
            <Form.Item
              name="dispatchedAt"
              label="Дата отправки через ЭДО"
              rules={[{ required: true, message: 'Укажите дату отправки через ЭДО' }]}
            >
              <DatePicker
                showTime
                style={{ width: '100%' }}
                data-testid="send-via-edo-date"
                format={DOCUMENT_UI_DATETIME_FORMAT}
              />
            </Form.Item>

            <Form.Item
              name="comment"
              label="Комментарий"
            >
              <Input.TextArea
                rows={3}
                maxLength={500}
                showCount
                placeholder="Комментарий для журнала комплекта (необязательно)"
                data-testid="send-via-edo-comment"
              />
            </Form.Item>
          </Form>

          <ClosingPackageTaskModalEventDateHint />
        </>
      )}
    </Modal>
  );
};

export default ClosingPackageSendViaEdoModal;
